import { render, staticRenderFns } from "./salaryComponent.vue?vue&type=template&id=5f831ff2&scoped=true&lang=html"
import script from "./salaryComponent.vue?vue&type=script&lang=js"
export * from "./salaryComponent.vue?vue&type=script&lang=js"
import style0 from "./salaryComponent.vue?vue&type=style&index=0&id=5f831ff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f831ff2",
  null
  
)

export default component.exports